import React from 'react'
import {Breadcrumb,LabledFriend,compareLabledFriend,screenType } from './myFunctions';
import { v4 as uuidv4 } from 'uuid';  // see https://stackoverflow.com/questions/62549457/error-err-package-path-not-exported-package-subpath-v4-is-not-defined-by
import SearchResultsListEntry from './SearchResultsListEntry';
export default function SearchResultsLisFirstName({searchItem,list,oym,dropBreadcrumb}) {
    let objectList=list.map(friend => oym.objectRef(friend));
    let filteredObjectList=objectList.filter(friendObject => {
        // console.log(searchItem.length);
        // console.log(friendObject.sortKey);
        // console.log(friendObject.sortKey.substr(0,searchItem.length));
        return (friendObject.name.substr(0,searchItem.length).toUpperCase()===searchItem.toUpperCase());
    });
    const labledFriendList =[];
    filteredObjectList.forEach(filteredObject=> {
        let labledFriend=new LabledFriend(filteredObject.name,filteredObject);
        labledFriendList.push(labledFriend);
    })
    labledFriendList.sort(compareLabledFriend);
    return (
        <center>
        <table>
            {labledFriendList.map(labledFriend => {
                console.log(labledFriend);
                return <SearchResultsListEntry key={uuidv4()} labledFriend={labledFriend} oym={oym} dropBreadcrumb={dropBreadcrumb}/> 
            })
        }
        </table>
        </center>  
    )
}